import CellLink from '@/components/GokuDataGrid/CellLink'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { Affiliate } from '@/modules/Affiliate/types'
import { generatePathDatacentral, paths } from '@/utils/path'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Tooltip, Typogaphy } from 'vnetwork-ui'
import { TFunction } from 'i18next'
import {
    AFFILIATE_STATUS_OPTIONS,
    AFFILIATE_TIER_OPTIONS,
} from '@/modules/Affiliate/constants'

const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 0,
    }).format(value)
}

export const affiliateListColumns = (
    t: TFunction
): GridColDefVNW<Affiliate>[] => [
    {
        field: 'referrer_name',
        headerName: t('affiliate_name'),
        sortable: true,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.affiliateDetail, {
                    id: String(row?.affiliate_id),
                })}
            >
                {row?.referrer_name}
            </CellLink>
        ),
        width: 200,
    },
    {
        field: 'referrer_email',
        headerName: t('email'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.referrer_email || '-'}</Typogaphy>
        ),
        width: 200,
    },
    {
        field: 'referral_code',
        headerName: t('referral_code'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy className="font-mono">{row?.referral_code}</Typogaphy>
        ),
        width: 120,
    },
    {
        field: 'tier',
        headerName: t('tier'),
        sortable: true,
        renderCell: ({ row }) => {
            const tier = AFFILIATE_TIER_OPTIONS(t)?.find(
                (item) => item?.value === row?.tier
            )

            return row?.tier ? (
                <CellStatus
                    label={tier?.label || row?.tier}
                    color={tier?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            ) : (
                <Typogaphy>-</Typogaphy>
            )
        },
        width: 100,
    },
    {
        field: 'commission_percent',
        headerName: t('commission'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.commission_percent}%</Typogaphy>
        ),
        width: 100,
    },
    {
        field: 'total_clicks',
        headerName: t('clicks'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.total_clicks || 0}</Typogaphy>
        ),
        width: 80,
    },
    {
        field: 'total_conversions',
        headerName: t('total_conversions'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.total_conversions || 0}</Typogaphy>
        ),
        width: 100,
    },
    {
        field: 'total_commission',
        headerName: t('total_commission'),
        sortable: false,
        renderCell: ({ row }) => (
            <Tooltip title={formatCurrency(row?.total_commission || 0)}>
                <Typogaphy>
                    {formatCurrency(row?.total_commission || 0)}
                </Typogaphy>
            </Tooltip>
        ),
        width: 150,
    },
    {
        field: 'status',
        headerName: t('status'),
        sortable: true,
        renderCell: ({ row }) => {
            const status = AFFILIATE_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row?.status
            )

            return (
                <CellStatus
                    label={status?.label || row?.status}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
        width: 100,
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        sortable: true,
        renderCell: ({ row }) => <CellDate date={row?.created_at} />,
        width: 150,
    },
]
